import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAp9m9P7Wlkh2_r9CPShDn2HJl9XoaeRt4",
  authDomain: "iotrade-9840d.firebaseapp.com",
  projectId: "iotrade-9840d",
  storageBucket: "iotrade-9840d.firebasestorage.app",
  messagingSenderId: "920466032609",
  appId: "1:920466032609:web:928cfc1d27d2948302f4a0",
  measurementId: "G-23C041Z9M8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

export default app;

